"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isValidClassName = exports.getAlias = exports.getSourcePath = exports.findDeclaration = exports.mergeRules = exports.INVALID_MERGE_OF = exports.transformMatchesOnRule = exports.expandCustomSelectors = exports.isValidDeclaration = exports.CUSTOM_SELECTOR_RE = void 0;
const path_1 = require("path");
const replace_rule_selector_1 = require("./replace-rule-selector");
const rule_1 = require("./helpers/rule");
const selector_1 = require("./helpers/selector");
exports.CUSTOM_SELECTOR_RE = /:--[\w-]+/g;
function isValidDeclaration(decl) {
    return typeof decl.value === 'string';
}
exports.isValidDeclaration = isValidDeclaration;
function expandCustomSelectors(rule, customSelectors, diagnostics) {
    if (rule.selector.includes(':--')) {
        rule.selector = rule.selector.replace(exports.CUSTOM_SELECTOR_RE, (extensionName, _matches, selector) => {
            if (!customSelectors[extensionName] && diagnostics) {
                diagnostics.warn(rule, `The selector '${rule.selector}' is undefined`, {
                    word: rule.selector,
                });
                return selector;
            }
            // TODO: support nested CustomSelectors
            return ':matches(' + customSelectors[extensionName] + ')';
        });
        return (rule.selector = transformMatchesOnRule(rule, false));
    }
    return rule.selector;
}
exports.expandCustomSelectors = expandCustomSelectors;
function transformMatchesOnRule(rule, lineBreak) {
    return (0, replace_rule_selector_1.replaceRuleSelector)(rule, { lineBreak });
}
exports.transformMatchesOnRule = transformMatchesOnRule;
const INVALID_MERGE_OF = (mergeValue) => {
    return `invalid merge of: \n"${mergeValue}"`;
};
exports.INVALID_MERGE_OF = INVALID_MERGE_OF;
// ToDo: move to helpers/mixin
function mergeRules(mixinAst, rule, mixinDecl, report) {
    let mixinRoot = null;
    const nestedInKeyframes = (0, rule_1.isChildOfAtRule)(rule, `keyframes`);
    mixinAst.walkRules((mixinRule) => {
        if ((0, rule_1.isChildOfAtRule)(mixinRule, 'keyframes')) {
            return;
        }
        if (mixinRule.selector === '&' && !mixinRoot) {
            if (mixinRule.parent === mixinAst) {
                mixinRoot = mixinRule;
            }
            else {
                const { selector } = (0, selector_1.scopeNestedSelector)((0, selector_1.parseSelectorWithCache)(rule.selector), (0, selector_1.parseSelectorWithCache)(mixinRule.selector));
                mixinRoot = 'NoRoot';
                mixinRule.selector = selector;
            }
        }
        else {
            const { selector } = (0, selector_1.scopeNestedSelector)((0, selector_1.parseSelectorWithCache)(rule.selector), (0, selector_1.parseSelectorWithCache)(mixinRule.selector));
            mixinRule.selector = selector;
        }
    });
    if (mixinAst.nodes) {
        let nextRule = rule;
        // TODO: handle rules before and after decl on entry
        mixinAst.nodes.slice().forEach((node) => {
            if (node === mixinRoot) {
                node.walkDecls((node) => {
                    rule.insertBefore(mixinDecl, node);
                });
            }
            else if (node.type === 'decl') {
                rule.insertBefore(mixinDecl, node);
            }
            else if (node.type === 'rule' || node.type === 'atrule') {
                const valid = !nestedInKeyframes;
                if (valid) {
                    if (rule.parent.last === nextRule) {
                        rule.parent.append(node);
                    }
                    else {
                        rule.parent.insertAfter(nextRule, node);
                    }
                    nextRule = node;
                }
                else {
                    report === null || report === void 0 ? void 0 : report.warn(rule, (0, exports.INVALID_MERGE_OF)(node.toString()));
                }
            }
        });
    }
    return rule;
}
exports.mergeRules = mergeRules;
function findDeclaration(importNode, test) {
    const fromIndex = importNode.rule.nodes.findIndex(test);
    return importNode.rule.nodes[fromIndex];
}
exports.findDeclaration = findDeclaration;
function getSourcePath(root, diagnostics) {
    const source = (root.source && root.source.input.file) || '';
    if (!source) {
        diagnostics.error(root, 'missing source filename');
    }
    else if (!(0, path_1.isAbsolute)(source)) {
        throw new Error('source filename is not absolute path: "' + source + '"');
    }
    return source;
}
exports.getSourcePath = getSourcePath;
function getAlias(symbol) {
    if (symbol._kind === 'class' || symbol._kind === 'element') {
        if (!symbol[`-st-extends`]) {
            return symbol.alias;
        }
    }
    return undefined;
}
exports.getAlias = getAlias;
function isValidClassName(className) {
    const test = /^-?[_a-zA-Z]+[_a-zA-Z0-9-]*$/g; // checks valid classname
    return !!className.match(test);
}
exports.isValidClassName = isValidClassName;
//# sourceMappingURL=stylable-utils.js.map